var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.0078125H513V341.992H0V-0.0078125Z",
    fill: "#003787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.0078125H513L285 227.992V341.992H228V227.992L0 -0.0078125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 180.492C277.487 180.492 294.5 163.479 294.5 142.492C294.5 121.505 277.487 104.492 256.5 104.492C235.513 104.492 218.5 121.505 218.5 142.492C218.5 163.479 235.513 180.492 256.5 180.492Z",
    fill: "#F9D90F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209 142.492H304L256.5 227.992L209 142.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 227.992L180.5 156.742H332.5L256.5 227.992Z",
    fill: "#CF142B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.0078125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMf);
export default __webpack_public_path__ + "static/media/MF.f48e1bbb0e53bd199db77a88d80a6917.svg";
export { ForwardRef as ReactComponent };